import classNames from 'classnames';
import {useI18n} from '../contexts/I18n.client';
import {interpolate} from 'utils/i18n';
import {Accordion} from './Accordion.client';
import {Container} from './Container.client';

export const FAQ = (props: {className?: string}) => {
  const {t} = useI18n();

  const data = [
    {
      title: t('faqComponent.items.whatIsLinkpop.question'),
      content: interpolate(t('faqComponent.items.whatIsLinkpop.answer'), {
        br: () => <br />,
      }),
    },
    {
      title: t('faqComponent.items.whatAreShoppableLinks.question'),
      content: interpolate(
        t('faqComponent.items.whatAreShoppableLinks.answer'),
        {
          br: () => <br />,
          pricinglink: (content) => (
            <a
              className={classNames('underline', 'text-blue-600')}
              href={t(
                'faqComponent.items.whatAreShoppableLinks.pricinglinkUrl',
              )}
              target="_blank"
              rel="noopener noreferrer"
            >
              {content}
            </a>
          ),
        },
      ),
    },
    {
      title: t('faqComponent.items.canIViewAnalytics.question'),
      content: t('faqComponent.items.canIViewAnalytics.answer'),
    },
    {
      title: t('faqComponent.items.isLinkpopFree.question'),
      content: t('faqComponent.items.isLinkpopFree.answer'),
    },
    {
      title: t('faqComponent.items.howDoesLinkInBioWork.question'),
      content: interpolate(
        t('faqComponent.items.howDoesLinkInBioWork.answer'),
        {
          br: () => <br />,
        },
      ),
    },
    {
      title: t('faqComponent.items.whatDoesLinkInBioMean.question'),
      content: interpolate(
        t('faqComponent.items.whatDoesLinkInBioMean.answer'),
        {
          br: () => <br />,
        },
      ),
    },
    {
      title: t('faqComponent.items.whereCanIUseLinkInBio.question'),
      content: interpolate(
        t('faqComponent.items.whereCanIUseLinkInBio.answer'),
        {
          qrcodelink: (content) => (
            <a
              className={classNames('underline', 'text-blue-600')}
              href={t('faqComponent.items.whereCanIUseLinkInBio.qrcodelinkUrl')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {content}
            </a>
          ),
        },
      ),
    },
    {
      title: t('faqComponent.items.canIPutALinkInTikTokBio.question'),
      content: t('faqComponent.items.canIPutALinkInTikTokBio.answer'),
    },
    {
      title: t('faqComponent.items.whoUsesLinkInBio.question'),
      content: t('faqComponent.items.whoUsesLinkInBio.answer'),
    },

    {
      title: t('faqComponent.items.doINeedToBeAShopifyMerchant.question'),
      content: interpolate(
        t('faqComponent.items.doINeedToBeAShopifyMerchant.answer'),
        {
          br: () => <br />,
        },
      ),
    },
  ];

  return (
    <Container
      className={classNames(
        'relative',
        'flex',
        'flex-col',
        'gap-y-4',
        props.className,
      )}
      backgroundGradientStart="light-green"
      backgroundGradientEnd="light-green"
    >
      <p
        className={classNames(
          'flex',
          'items-baseline',
          'justify-center',
          'text-center',
          'mb-1',
        )}
      >
        <span
          className={classNames(
            'font-bold',
            'text-4xl',
            'leading-10',
            'md:text-5xl',
            'md:leading-[52px]',
            'lg:text-6xl',
            'lg:leading-[66px]',
          )}
        >
          {t('faqComponent.title')}
        </span>
      </p>
      {data.map((item) => (
        <Accordion key={item.title} title={item.title}>
          {item.content}
        </Accordion>
      ))}
    </Container>
  );
};
